import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  useColorScheme,
  StyleSheet,
  Image,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const MainMenuScreen = ({ navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';

  const mainOptions = [
    {
      name: '健康管理中心',
      icon: 'fitness',
      screen: 'Home',
      color: '#2563eb',
      description: '全面管理您的健康'
    },
    {
      name: '个人中心',
      icon: 'person',
      screen: 'Profile',
      color: '#0891b2',
      description: '管理个人信息和设置'
    },
  ];

  const foodOptions = [
    {
      name: '食物管理',
      icon: 'nutrition',
      screen: 'FoodHome',
      color: '#ea580c',
      description: '浏览食物数据库'
    },
    {
      name: '智能食物录入',
      icon: 'mic',
      screen: 'FoodInputHome',
      color: '#8b5cf6',
      description: '语音、图像多种方式录入'
    },
    {
      name: '我的收藏',
      icon: 'heart',
      screen: 'FoodFavorites',
      color: '#ec4899',
      description: '管理您收藏的食物'
    },
    {
      name: '营养目标',
      icon: 'analytics',
      screen: 'PersonalNutrition',
      color: '#0d9488',
      description: '设置个人营养目标'
    },
  ];

  const dataAnalysisOptions = [
    {
      name: '健康数据概览',
      icon: 'stats-chart',
      screen: 'HealthDataOverview',
      color: '#2563eb',
      description: '查看基础指标与营养达成度'
    },
    {
      name: '营养素分布分析',
      icon: 'pie-chart',
      screen: 'NutrientDistribution',
      color: '#10b981',
      description: '了解营养素占比与均衡度'
    },
    {
      name: '时间维度分析',
      icon: 'calendar',
      screen: 'TimeAnalysis',
      color: '#8b5cf6',
      description: '追踪营养摄入趋势变化'
    },
    {
      name: '食物摄入提醒与建议',
      icon: 'nutrition-outline',
      screen: 'FoodRecommendation',
      color: '#0d9488',
      description: '获取个性化饮食改进建议'
    },
  ];

  // 添加社交互动选项
  const socialOptions = [
    {
      name: '社交健康',
      icon: 'globe',
      screen: 'SocialHome',
      color: '#6366f1',
      description: '社交互动功能主页'
    },
    {
      name: '社区动态',
      icon: 'people',
      screen: 'CommunityFeed',
      color: '#8b5cf6',
      description: '查看用户分享的健康记录'
    },
    {
      name: '好友互动',
      icon: 'person-add',
      screen: 'FriendList',
      color: '#0891b2',
      description: '管理好友和数据对比'
    },
    {
      name: '健康排行榜',
      icon: 'podium',
      screen: 'Rankings',
      color: '#4CAF50',
      description: '查看好友圈中的排名'
    },
    {
      name: '健康挑战',
      icon: 'trophy',
      screen: 'Challenges',
      color: '#f59e0b',
      description: '参与挑战提升健康水平'
    },
    {
      name: '经验分享',
      icon: 'chatbubbles',
      screen: 'ExperienceSharing',
      color: '#10b981',
      description: '分享健康饮食心得'
    },
    {
      name: '互助小组',
      icon: 'people-circle',
      screen: 'SupportGroup',
      color: '#ec4899',
      description: '加入互助小组共同进步'
    },
    {
      name: '成就系统',
      icon: 'ribbon',
      screen: 'Achievements',
      color: '#ea580c',
      description: '查看您获得的成就徽章'
    },
  ];

  // 处理功能选项点击
  const handleOptionPress = (screen) => {
    console.log(`Navigating to ${screen}`);
    navigation.navigate(screen);
  };

  // 社交健康部分
  const renderSocialSection = () => {
    return (
      <>
        <Text style={{
          fontSize: 20,
          fontWeight: 'bold',
          marginBottom: 16,
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          社交健康
        </Text>

        <View style={{ 
          flexDirection: 'row', 
          flexWrap: 'wrap', 
          justifyContent: 'space-between',
          marginBottom: 24,
        }}>
          {socialOptions.map((option) => (
            <TouchableOpacity
              key={option.name}
              style={{
                width: '48%',
                marginBottom: 16,
                borderRadius: 16,
                padding: 20,
                backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 4,
                elevation: 3,
              }}
              onPress={() => handleOptionPress(option.screen)}
            >
              <View style={{
                width: 56,
                height: 56,
                borderRadius: 28,
                backgroundColor: option.color,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 12,
              }}>
                <Ionicons name={option.icon} size={30} color="white" />
              </View>
              <Text style={{
                fontSize: 18,
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
                marginBottom: 4,
              }}>
                {option.name}
              </Text>
              <Text style={{
                fontSize: 14,
                color: isDarkMode ? '#e0e0e0' : '#6b7280',
              }}>
                {option.description}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </>
    );
  };

  return (
    <ScrollView 
      style={{
        flex: 1,
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      <View style={{ 
        padding: 24, 
        borderRadius: 16, 
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
        marginBottom: 20,
        alignItems: 'center',
      }}>
        <View style={{
          width: 80,
          height: 80,
          borderRadius: 40,
          backgroundColor: '#2563eb',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
        }}>
          <Ionicons name="medkit" size={40} color="white" />
        </View>
        <Text style={{ 
          fontSize: 28, 
          fontWeight: 'bold', 
          color: isDarkMode ? 'white' : '#1e3a8a',
          marginBottom: 8,
          textAlign: 'center',
        }}>
          健康管理助手
        </Text>
        <Text style={{ 
          fontSize: 16, 
          color: isDarkMode ? '#e0e7ff' : '#3b82f6',
          textAlign: 'center',
        }}>
          您的个人健康与营养管理专家
        </Text>
      </View>

      <Text style={{
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 16,
        color: isDarkMode ? 'white' : '#1f2937',
      }}>
        用户中心
      </Text>

      <View style={{ 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between',
        marginBottom: 24,
      }}>
        {mainOptions.map((option) => (
          <TouchableOpacity
            key={option.name}
            style={{
              width: '48%',
              marginBottom: 16,
              borderRadius: 16,
              padding: 20,
              backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 3,
            }}
            onPress={() => handleOptionPress(option.screen)}
          >
            <View style={{
              width: 56,
              height: 56,
              borderRadius: 28,
              backgroundColor: option.color,
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 12,
            }}>
              <Ionicons name={option.icon} size={30} color="white" />
            </View>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {option.name}
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#6b7280',
            }}>
              {option.description}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      <Text style={{
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 16,
        color: isDarkMode ? 'white' : '#1f2937',
      }}>
        食物管理
      </Text>

      <View style={{ 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between',
        marginBottom: 24,
      }}>
        {foodOptions.map((option) => (
          <TouchableOpacity
            key={option.name}
            style={{
              width: '48%',
              marginBottom: 16,
              borderRadius: 16,
              padding: 20,
              backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 3,
            }}
            onPress={() => handleOptionPress(option.screen)}
          >
            <View style={{
              width: 56,
              height: 56,
              borderRadius: 28,
              backgroundColor: option.color,
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 12,
            }}>
              <Ionicons name={option.icon} size={30} color="white" />
            </View>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {option.name}
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#6b7280',
            }}>
              {option.description}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      <Text style={{
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 16,
        color: isDarkMode ? 'white' : '#1f2937',
      }}>
        数据分析
      </Text>

      <View style={{ 
        flexDirection: 'row', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between',
        marginBottom: 24,
      }}>
        {dataAnalysisOptions.map((option) => (
          <TouchableOpacity
            key={option.name}
            style={{
              width: '48%',
              marginBottom: 16,
              borderRadius: 16,
              padding: 20,
              backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 3,
            }}
            onPress={() => handleOptionPress(option.screen)}
          >
            <View style={{
              width: 56,
              height: 56,
              borderRadius: 28,
              backgroundColor: option.color,
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: 12,
            }}>
              <Ionicons name={option.icon} size={30} color="white" />
            </View>
            <Text style={{
              fontSize: 18,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {option.name}
            </Text>
            <Text style={{
              fontSize: 14,
              color: isDarkMode ? '#e0e0e0' : '#6b7280',
            }}>
              {option.description}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* 社交互动部分 */}
      {renderSocialSection()}

    </ScrollView>
  );
};

export default MainMenuScreen; 